import { Controller } from "web-ui/controller"
import { interactiveSelector } from "web-ui/interactive-elements"

// A cell contains its own controls when one of these is present. The row's
// primary anchor is a plain `a` (never `.button`, per the component's link
// convention), so it is excluded and the space around it stays navigable, while
// button-styled action links (`a.button`) and action buttons count.
// - Aaron, Sun Jul 26 2026
const cellControlSelector = "button, a.button, input, select, textarea, label, summary, [role='button'], [contenteditable='true'], [data-sortable-handle]"

// Connects to data-controller="table-row-links"
export default class extends Controller {
  static events = {
    "click tr.link": "navigate",
    "auxclick tr.link": "navigate"
  }

  navigate(event, row) {
    const anchor = row.querySelector("a[href]")
    if (!anchor) return

    // Clicks on interactive descendants (the anchor itself, buttons, form
    // controls) perform their own behavior and must not be re-delegated.
    // - Aaron, Sun Jul 26 2026
    if (event.target.closest(interactiveSelector)) return

    // A near-miss beside a cell's own controls (action buttons, links, form
    // inputs) does not follow the row link. An empty cell still navigates.
    // - Aaron, Sun Jul 26 2026
    //
    // A click that lands on no cell at all is not a click on the row's content.
    // The row's cells cover the row, so this is a click a gesture produced
    // rather than one the pointer landed on: a drag dispatches its click on the
    // nearest ancestor shared by the press and the release, which is the row
    // itself when the two are in different cells. - Mac, Pedro, Thu Aug 6 2026
    const cell = event.target.closest("td, th")
    if (!cell) return
    if (cell.querySelector(cellControlSelector)) return

    // A drag-to-select gesture ends in a click; honor the selection instead of
    // navigating so cell text can be copied.
    if (window.getSelection().toString().trim()) return

    if (event.type === "auxclick" && event.button !== 1) return

    const newTab = event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1
    if (newTab) {
      window.open(anchor.href, "_blank")
    } else {
      anchor.click()
    }
  }
}
